<template>
  <div class="nextdetail">
    <div class="nextdetail-red">观看页地址,请用URLEncode进行编码后作为参数传递</div>
    <div v-if="type =='pc'" style="margin: 10px 0;font-weight: 600;">PC</div>
    <div class="mgtbl" v-if="type =='pc'">
      备注:
      <div class="mgtl-20">
        PC上,不分横竖屏,都是: <a :href="pcUrl" target="_blank">{{pcUrl}}</a>
      </div>
    </div>
    <div style="margin: 10px 0;font-weight: 600;" v-if="type =='app'">APP</div>
    <div class="mgtbl" v-if="type =='app'">
      备注:
      <div class="mgtl-20" v-if="detailData.play_mode == 2">
        <span>横屏:</span>
        <a :href="watchUrl" target="_blank">{{watchUrl}}</a>
      </div>
      <div class="mgtl-20" v-if="detailData.play_mode == 1">
        <span>竖屏:</span>
        <a :href="verticalScreenUrl" target="_blank">{{verticalScreenUrl}}</a>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props:{
    baseUrl:{
      type:String,
      default:''
    },
    detailData:{
      type: Object,
      default: () => {
        return {};
      }
    },
    type:String
  },
  data(){
    return {
      pcUrl:'',           // pc
      watchUrl:'',           // app横屏
      verticalScreenUrl:'',  // app竖屏
    }
  },
  methods:{
    PCUrl(){
      this.pcUrl = this.baseUrl + '/pcwatch/?liveid='+this.detailData.liveid+'&enterprise_id='+this.detailData.enterprise_id
    },
    watchAPPUrl(){
      this.watchUrl = this.baseUrl + '/watch/?liveid='+this.detailData.liveid+'&enterprise_id='+this.detailData.enterprise_id
    },
    verticalScreenAPPUrl(){
      this.verticalScreenUrl = this.baseUrl + '/verticalScreen/?liveid='+this.detailData.liveid+'&/enterprise_id='+this.detailData.enterprise_id
    },

  }
}
</script>
<style lang="less" scoped>
.mgtl-20{
  margin-top: 10px;
  margin-left: 20px
}
.mgtbl{
  margin: 10px 0 10px 20px
}

.nextdetail{
  font-size: 16px;
  color: #333;
  .nextdetail-red{
    color: red;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/liveList/watchSet/nextDetail.vue